// extracted by mini-css-extract-plugin
export var container = "_99-0";
export var error = "_99-9";
export var label = "_99-5";
export var light = "_99-6";
export var md = "_99-3";
export var sm = "_99-2";
export var thin = "_99-8";
export var thinBold = "_99-7";
export var vertical = "_99-4";
export var xs = "_99-1";